import React from "react";
import Line from "../../../assets/line2.svg";
import MainImg from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_browser_extension.webp";

export default function TestimonialOne() {
  return (
    <div>
      <h2 className="text-3xl bg-gray-50 pt-8 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-16">
        Find Business{" "}
        <span className="relative inline-block">
          Contacts{" "}
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>{" "}
        That Connect
      </h2>
      <div className="bg-gray-50 px-8 pt-8 pb-1">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div
            className={`flex justify-center items-center mt-8 md:mt-0 md:w-[45%] md:order-1`}
          >
            <img
              src={MainImg}
              alt="Expanded section preview"
              className="md:w-full w-96"
            />
          </div>

          <div className={`text-left md:w-[55%] md:order-2 md:p-6`}>
            <p className="text-[22px] my-6 pt-10">
              We're all about getting you the right emails. Our 98% accuracy
              means your messages land where they should. We put every contact
              through a rigorous verification process, so you can reach out
              knowing you're talking to real people. <br />
              Say goodbye to bounces and hello to better connections!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
